import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LogOut, Settings } from 'lucide-react';
import { getSubmodules } from '../data/specialtyStructure';

const SubmoduleView = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const { specialty } = useParams();
  const submodules = getSubmodules(decodeURIComponent(specialty));
  const [hoveredItem, setHoveredItem] = useState(null);

  const playPencilSound = () => {
    try {
      const audio = new Audio('https://customer-assets.emergentagent.com/job_13d67352-1aa7-430c-b46e-966b83d4fc8c/artifacts/wfi9fn7o_pencil_scribble_7-389260.mp3');
      audio.volume = 1.0;
      audio.play();
    } catch (error) {
      console.log('Audio not supported');
    }
  };

  const handleSubmoduleClick = (submodule) => {
    playPencilSound();
    setTimeout(() => {
      navigate(`/topics/${encodeURIComponent(specialty)}/${encodeURIComponent(submodule)}`);
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 py-4 px-4 z-50 bg-white">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <button
            onClick={() => navigate('/cuestionarios')}
            className="flex items-center space-x-2 text-black font-medium text-sm hover:text-gray-600 transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            <span>Volver</span>
          </button>
          
          <div className="flex items-center space-x-2">
            {user.is_admin && (
              <button
                onClick={() => navigate('/admin')}
                className="bg-white rounded-full p-1.5 border border-black hover:bg-gray-100 transition-all"
              >
                <Settings size={14} className="text-black" />
              </button>
            )}
            
            <button
              onClick={onLogout}
              className="bg-white rounded-full p-1.5 border border-black hover:bg-gray-100 transition-all"
            >
              <LogOut size={14} className="text-black" />
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="min-h-screen flex flex-col items-center justify-center px-4 pt-16">
        {/* Title */}
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black mb-12 text-center">
          {decodeURIComponent(specialty)}
        </h1>

        {/* Submodules List with Circles */}
        <nav className="text-center">
          <ul className="space-y-6 sm:space-y-8">
            {submodules.map((submodule, index) => (
              <li 
                key={submodule}
                className="transform transition-all duration-300"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <button
                  onClick={() => handleSubmoduleClick(submodule)}
                  onMouseEnter={() => setHoveredItem(submodule)}
                  onMouseLeave={() => setHoveredItem(null)}
                  className="group flex items-center justify-center space-x-4 text-xl sm:text-2xl lg:text-3xl font-medium text-gray-700 hover:text-black transition-colors duration-300"
                >
                  {/* Circle indicator */}
                  <span 
                    className={`relative w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 border-gray-400 transition-all duration-300 flex-shrink-0 ${
                      hoveredItem === submodule ? 'border-black' : ''
                    }`}
                  >
                    <span 
                      className={`absolute inset-0.5 rounded-full bg-black transition-all duration-300 ${
                        hoveredItem === submodule ? 'scale-100 opacity-100' : 'scale-0 opacity-0'
                      }`}
                    ></span>
                  </span>
                  
                  {/* Text label */}
                  <span className="transition-all duration-300 group-hover:tracking-wide">
                    {submodule}
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default SubmoduleView;
